module.exports = __webpack_public_path__ + "images/help/guide_video_cal-f0fb05676e0d1944c234487562615b8f.png";